'use strict'

import get from 'lodash/get'
import find from 'lodash/find'

/**
 * #### Sample Response ####
 *
 {
    "resultCode": 0,
    "resultMessage": "SUCCESS:Successfully fetched results",
    "total": 7,
    "records": [
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-10"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-10",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 11:38:51",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": false,
          "currency": "USD",
          "amtPerPax": 541.29
        },
        "viewers": 5
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-11"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-11",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 11:46:53",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": true,
          "currency": "USD",
          "amtPerPax": 403.5
        },
        "viewers": 18
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-12"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-12",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 11:42:13",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": true,
          "currency": "USD",
          "amtPerPax": 607.3
        },
        "viewers": 10
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-13"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-13",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 11:49:48",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": true,
          "currency": "USD",
          "amtPerPax": 685.41
        },
        "viewers": 7
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-14"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-14",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 11:48:56",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": true,
          "currency": "USD",
          "amtPerPax": 633.9
        },
        "viewers": 21
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-15"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-15",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 14:40:04",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": true,
          "currency": "USD",
          "amtPerPax": 733.15
        },
        "viewers": 27
      },
      {
        "destinations": [
          "LON"
        ],
        "origins": [
          "NYC"
        ],
        "dates": [
          "2017-12-18"
        ],
        "cabinClass": "ECO",
        "disclosure": "D",
        "groupByOrigDestDateKey": "NYCLON2017-12-18",
        "offerType": "AIR",
        "cacheCreationDateTime": "2017-12-08 15:02:49",
        "paxChild": 0,
        "paxInfant": 0,
        "paxAdult": 1,
        "posFipsCountryCode": "US",
        "minimumFare": {
          "isPrivateFare": false,
          "currency": "USD",
          "amtPerPax": 567
        },
        "viewers": 3
      }
    ],
    "viewers": 91
  }
 */

// returns formatted elastic search query results
export function buildFlexDatesPricingObj(esResultsObj = [], trips) {
  const searchDepartDate = get(trips, '[0].departDateRange.fromDate')
  const searchReturnDate = get(trips, '[1].departDateRange.fromDate', '')

  return esResultsObj.map(itinerary => {
    return flexDatePricingObj(itinerary, searchDepartDate, searchReturnDate)
  })
}

export function flexDatePricingObj(
  itinerary,
  searchDepartDate,
  searchReturnDate
) {
  const lisOfStops = get(itinerary, 'minimumFare.listOfStops', [])
  const firstSliceStop = find(lisOfStops, stops => stops?.sliceId === 1)
  const flexDatePriceResult = {
    origin1: get(itinerary, 'origins[0].airportCode', null),
    destination1: get(itinerary, 'destinations[0].airportCode', null),
    departDate: itinerary?.dates[0],
    origin2: get(itinerary, 'origins[1].airportCode', null),
    destination2: get(itinerary, 'destinations[1].airportCode', null),
    returnDate: itinerary?.dates[1] || null,
    fare: itinerary?.minimumFare?.amtPerPax,
    cabinClass: itinerary?.cabinClass,
    numAdult: itinerary?.paxAdult,
    numChild: itinerary?.paxChild,
    numInfant: itinerary?.paxInfant,
    numStops: firstSliceStop ? firstSliceStop?.stops : 0
  }
  const itinDepartDate = itinerary?.dates[0]
  const itinReturnDate = get(itinerary, 'dates[1]', '')
  if (
    itinDepartDate === searchDepartDate &&
    itinReturnDate === searchReturnDate
  ) {
    Object.assign(flexDatePriceResult, {
      viewers: itinerary?.viewers,
      isSameDate: true
    })
  }
  return flexDatePriceResult
}
